@if (modalStep == 'contrib_1') {
  <div>
    <p class="m-0">Contribuição mensal atual</p>
    <h2 class="title">{{valorAtual| currency:'R$'}}</h2>
    <div class="row">
      <div class="col-12 col-md-9" [formGroup]="formContrib">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text border-0 bg-transparent pt-0 pr-4 pb-2 pl-0 font-weight-bold" for="novacontrib">
              Nova contribuição mensal:
            </label>
          </div>
          <input
            class="form-control"
            type="text"
            placeholder="000,00"
            maxlength="10"
            currencyMask
            mask="separator.2"
            prefix="R$ "
            thousandSeparator="."
            decimalMarker=","
            [dropSpecialCharacters]="true"
            formControlName="valor">
            <div class="input-group-append">
              <small class="input-group-text border-0 bg-transparent">(mínimo: {{valorMinimo| currency:'R$'}})</small>
            </div>
          </div>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text border-0 bg-transparent pt-0 pr-4 pb-2 pl-0 font-weight-bold" for="novacontrib">Assinatura Eletrônica:</label>
            </div>
            <input class="mb-3 form-control" type="password" formControlName="assinatura">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col text-right">
          <button class="btn btn-success" [disabled]="!formContrib.valid || loading || valorMinimo==0" (click)="salvarAlteracao()">
            Salvar
            @if (loading) {
              <i class="fas fa-spinner fa-spin"></i>
            }
          </button>
        </div>
      </div>
    </div>
  }

  @if (modalStep == 'contrib_2') {
    <div>
      <div class="icon-center small">
        <i class="far fa-check-circle"></i>
      </div>
      <h3 class="title my-2 my-md-4">
        Contribuição mensal alterada com sucesso!
      </h3>
    </div>
  }
